import { Typography, Drawer, Descriptions, Spin } from "antd"
import React, { useEffect, useState } from "react"
import axiosInstance from "../../axios/axiosConfig"

const { Link } = Typography

export default function ViewOrderDetailsDieCut({ knifeCode }) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [knife, setKnife] = useState({})

  useEffect(() => {
    if (knifeCode) {
      const searchByCode = async () => {
        setLoading(true)
        try {
          const response = await axiosInstance.get(
            `/api/searchByCode?code=${encodeURIComponent(knifeCode)}`
          )
          console.log(response.data) // Handle the response data
          if (response.data) {
            setKnife(response.data)
          } else {
            setKnife({})
          }
        } catch (error) {
          console.error("Failed to fetch data:", error)
        } finally {
          setLoading(false)
        }
      }
      return searchByCode()
    }
  }, [knifeCode])

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  if (loading) {
    return <Spin />
  }

  return (
    <div>
      <Link onClick={showDrawer}>{knifeCode}</Link>
      <Drawer title="Diec Cut Info" placement="left" onClose={onClose} open={open}>
        <Descriptions column={1}>
          <Descriptions.Item label="Client">{knife.Client}</Descriptions.Item>
          <Descriptions.Item label="Code">{knife.code}</Descriptions.Item>
          <Descriptions.Item label="Width">{knife.width}</Descriptions.Item>
          <Descriptions.Item label="Height">{knife.height}</Descriptions.Item>
          <Descriptions.Item label="Rowss">{knife.rowss}</Descriptions.Item>
          <Descriptions.Item label="Space between rows">{knife.spaceBetweenRows}</Descriptions.Item>
          <Descriptions.Item label="Gap raport">{knife.gapRaport}</Descriptions.Item>
          <Descriptions.Item label="User or New">{knife.Used_Or_New}</Descriptions.Item>
          <Descriptions.Item label="Type of Form">{knife.TypeOfForm}</Descriptions.Item>
          <Descriptions.Item label="Shape">
            <Link href={knife.SHAPE} target="_blank">
              show
            </Link>
          </Descriptions.Item>
          <Descriptions.Item label="Z raport">{knife.Z_raports}</Descriptions.Item>
          <Descriptions.Item label="Z">{knife.Z}</Descriptions.Item>
          <Descriptions.Item label="X">{knife.x}</Descriptions.Item>
          <Descriptions.Item label="Knife Width MM">{knife.Knives_WIDTH_mm}</Descriptions.Item>
          <Descriptions.Item label="Material width">{knife.Material_width}</Descriptions.Item>
          <Descriptions.Item label="Date X">{knife.DATE_X}</Descriptions.Item>
          <Descriptions.Item label="Arsoma_knife_width_until_275mm_Z">
            {knife.Arsoma_knife_width_until_275mm_Z ? "yes" : "no"}
          </Descriptions.Item>
          <Descriptions.Item label="Cutter_Knives_Width_until_313mm">
            {knife.Cutter_Knives_Width_until_313mm ? "yes" : "no"}
          </Descriptions.Item>
          <Descriptions.Item label="EM_340_knife_width_until_325_Z">
            {knife.EM_340_knife_width_until_325_Z ? "yes" : "no"}
          </Descriptions.Item>
          <Descriptions.Item label="Hot_Foil">{knife.Hot_Foil ? "yes" : "no"}</Descriptions.Item>
          <Descriptions.Item label="Form Rowss">{knife.Form_Rows}</Descriptions.Item>
          <Descriptions.Item label="Rotary or Semi">{knife.Rotary_Or_SemiRotary}</Descriptions.Item>
          <Descriptions.Item label="Radius">{knife.Radius}</Descriptions.Item>
        </Descriptions>
      </Drawer>
    </div>
  )
}
